<template>
  <div class="bind">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div v-if="!personalInfo.staff && filedList.includes('faceImg')" :class="filedMustList.includes('gender') ? 'van-cell--required van-cell hasinput' : 'van-cell hasinput'">
      <span>头像</span>
      <div class="avatar">
        <img
          v-if="!personalData.faceImg"
          src="../../../assets/img/avatar.png"
          class="_avatar"
          @click="showPopup"
        >
        <img v-else :src="baseURL + personalData.faceImg" class="_avatar" alt @click="showPopup">
        <van-icon name="arrow" @click="showPopup" />
      </div>
      <div v-show="imgErr" class="errMsg">
        <van-icon name="warning" />请上传清晰人像用于人脸通行
      </div>
    </div>
    <div v-if="personalInfo.staff" class="van-cell hasinput">
      <span>头像</span>
      <div class="avatar">
        <img
          v-if="!personalData.faceImg"
          src="../../../assets/img/avatar.png"
          class="_avatar"
        >
        <img v-else :src="baseURL + personalData.faceImg" class="_avatar" alt>
      </div>
    </div>
    <common-input
      v-model="personalData.name"
      v-if="!personalInfo.staff && filedList.includes('name')"
      :required="filedMustList.includes('name')"
      :err-msg="nameErrMsg"
      :max="20"
      :disabled="personalInfo.staff"
      display="false"
      name="姓名"
      placeholder="请输入姓名"
      color="#323233"
      @inputBlured="checkName"
    />
    <van-cell v-else class="van-field hasinput" title="姓名">
      <div style="color: #323233">
        {{ personalData.name }}
      </div>
    </van-cell>
    <van-cell :class="filedMustList.includes('gender') ? 'van-cell--required van-field hasinput' : 'van-field hasinput'" title="性别" v-if="!personalInfo.staff && filedList.includes('gender')">
      <van-radio-group v-model="personalData.gender">
        <van-radio name="MALE">男</van-radio>
        <van-radio name="FEMALE">女</van-radio>
      </van-radio-group>
    </van-cell>
    <van-cell class="van-field hasinput" title="性别" v-else>
      <div style="color: #323233">
        {{ personalData.gender === 'MALE' ? '男' : '女' }}
      </div>
    </van-cell>
    <common-input
      v-if="!personalInfo.staff && filedList.includes('phone')"
      v-model.trim="personalData.phone"
      :err-msg="phonErrMsg"
      :max="11"
      :required="filedMustList.includes('phone')"
      display="false"
      type="tel"
      name="手机号"
      placeholder="请输入手机号"
      color="#323233"
      @inputBlured="checkPhone"
      @inputChanged="checkPhone"
    />
    <van-cell v-else class="van-field hasinput" title="手机号">
      <div style="color: #323233">
        {{ personalData.phone }}
      </div>
    </van-cell>
    <div v-show="showCaptcha && filedList.includes('phone')" class="van-cell hasinput">
        <span
          :class="codeFlag ? '' : 'active'"
          class="get-code"
          @click="getVerificationCode"
        >{{ btnName }}</span>
      <input
        v-model="personalData.smsCode"
        class="van-field__control code_input"
        placeholder="请输入验证码"
        type="number"
        @blur="checkCode"
        @input="checkCode"
      >
      <div v-show="codeErrMsg" class="errMsg">
        <svg-icon icon-class="err" />
        {{ codeErrMsg }}
      </div>
    </div>
    <common-input
      v-if="!personalInfo.staff && filedList.includes('company')"
      v-model="personalData.company"
      :required="filedMustList.includes('company')"
      :err-msg="companyErrMsg"
      display="false"
      name="公司名称"
      placeholder="请输入公司名称"
      color="#323233"
      @inputBlured="checkCompany"
    />
    <van-cell v-else class="van-field hasinput" title="公司名称">
      <div style="color: #323233; text-overflow:ellipsis; overflow:hidden; white-space:nowrap; width:250px;">
        {{ personalData.company }}
      </div>
    </van-cell>
    <van-button
      v-show="!personalInfo.staff"
      class="sub_btn"
      type="info"
      @click="submitPersonalData"
    >提交</van-button>
    <van-popup v-model="show">
      <div class="upload">
        <h5>拍照示例</h5>
        <div class="right_img">
          <img alt src="../../../assets/img/img.png">
        </div>
        <p class="tip_text">温馨提示：为保证审核顺利通过，请保持人脸完整清晰，勿用美颜。</p>
        <div class="wrong_img">
          <div>
            <img alt src="../../../assets/img/img1.png">
            <p>照片模糊</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img2.png">
            <p>比例过小</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img3.png">
            <p>人脸不完整</p>
          </div>
          <div>
            <img alt src="../../../assets/img/img4.png">
            <p>侧脸拍照</p>
          </div>
        </div>
        <van-uploader :before-read="beforeRead">
          <van-button type="info" style="display: flex; justify-content: center">
            <svg-icon icon-class="album" />从相册选择
          </van-button>
        </van-uploader>
        <van-uploader :before-read="beforeRead" capture="camera">
          <van-button type="default" style="display: flex; justify-content: center">
            <svg-icon icon-class="picture" />拍照
          </van-button>
        </van-uploader>
      </div>
    </van-popup>
    <van-dialog v-model="visible" :before-close="beforeClose" title="请输入计算结果" show-cancel-button>
      <div style="display: flex; padding: 15px 20px">
        <img :src="captchaInfo.captcha" alt="" @click="getImg">
        <van-icon name="replay" color="#3b86ff" @click="getImg" />
        <input
          v-model="personalData.captchaResult"
          class="van-field__control code_input"
          placeholder="请输入计算结果"
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import commonInput from '@/components/commonInput';
import lrz from 'lrz';
import { VueCropper } from 'vue-cropper';

import {
  GetVisitorInfo,
  GetStaffInfo,
  GetVerificationCode,
  Upload,
  SubmitPersonalData, getCaptcha
} from '@/api/user';
import config from '@/common/config';
import fileUtils from '@/utils/fileUtils';
import { Toast } from 'vant';
import {fieldsByVisitor} from "@/api/home";
export default {
  name: 'PersonalData',
  components: {
    commonInput,
    VueCropper
  },
  data() {
    return {
      imgurl: '',
      imgurl1: '',
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      subHead: '个人资料',
      personalData: {
        faceImg: '',
        name: '',
        gender: '',
        phone: '',
        smsCode: '',
        company: '',
        captchaResult: null
      },
      captchaInfo: {
        open: false
      },
      showCaptcha: false, // 是否显示输入验证码,false-不显示；true-显示
      resPhone: '',
      btnName: '获取验证码',
      btnDefault: '重发验证码',
      countDown: 60,
      codeInterval: null,
      nameErrMsg: '', // 姓名输入提示
      phonErrMsg: '', // 手机号校验提示
      imgErr: false, // 人脸识别失败提示
      codeErrMsg: false, // 验证码校验失败提示
      show: false,
      disFlag: true,
      visible: false,
      showCropper: false,
      imageFileName: '',
      companyErrMsg: '',
      option: {
        img: '',
        outputSize: 0.8,
        info: false, // 裁剪框的大小信息
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: window.innerWidth - 100 + 'px', // 默认生成截图框宽度
        autoCropHeight: window.innerWidth - 100 + 'px', // 默认生成截图框高度
        high: true, // 是否按照设备的dpr 输出等比例图片
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: '100% auto' // 图片默认渲染方式
      },
      filedList: [],
      filedMustList: [],
      codeFlag: true, // 验证码校验失败提示，
      personalInfo: {} // 用户信息
    };
  },
  watch: {
    'personalData.phone': {
      handler(nv) {
        //  this.showCaptcha = this.resPhone !== nv
        if (this.checkPhone() && this.resPhone !== nv) {
          this.showCaptcha = true;
        } else {
          this.showCaptcha = false;
        }
      }
    }
  },
  created() {
    this.getPersonalData();
    this.getImg();
    const filedList = [];
    const filedMustList = [];
    fieldsByVisitor({}).then(res => {
      res.data.forEach(item => {
        filedList.push(item.fieldName);
        if (item.must) {
          filedMustList.push(item.fieldName);
        }
      });
      this.filedList = filedList;
      this.filedMustList = filedMustList;
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getPersonalData() {
      this.personalInfo = JSON.parse(
        localStorage.getItem('personalInfo') || '{}'
      );
      switch (this.personalInfo.staff) {
        case false:
          this.getVisitorInfo();
          break;
        case true:
          this.getStaffInfo();
          break;
        default:
          break;
      }
    },
    // 获取访客信息
    getVisitorInfo() {
      const data = {};
      GetVisitorInfo(data).then(response => {
        this.personalData = response.data;
        this.resPhone = response.data.phone;
      });
    },
    // 获取员工信息
    getStaffInfo() {
      const data = {};
      GetStaffInfo(data).then(response => {
        this.personalData = response.data;
        this.resPhone = response.data.phone;
      });
    },
    // 访客修改个人资料
    submitPersonalData() {
      if (this.resPhone !== this.personalData.phone) {
        if (!this.personalData.smsCode) {
          this.codeError = true;
          return;
        } else {
          this.codeError = false;
        }
        if (this.checkName() && this.checkPhone() && this.checkCode() && this.checkImg() && this.checkCompany()) {
          this.disFlag = true;
          SubmitPersonalData(this.personalData)
            .then(res => {
              this.$toast.success({
                icon: 'checked',
                message: '提交成功',
                mask: true,
                className: 'newToast'
              });
              this.disFlag = false;
              this.$router.push({ path: '/user' });
            })
            .catch(err => {
              console.log(err);
              this.disFlag = false;
            });
        }
      } else {
        if (this.checkName() && this.checkPhone() && this.checkCode() && this.checkImg() && this.checkCompany()) {
          this.disFlag = true;
          SubmitPersonalData(this.personalData)
            .then(res => {
              this.$toast.success({
                icon: 'checked',
                message: '提交成功',
                mask: true,
                className: 'newToast'
              });
              this.disFlag = false;
              this.$router.push({ path: '/user' });
            })
            .catch(err => {
              console.log(err);
              this.disFlag = false;
            });
        }
      }
    },
    beforeRead(file) {
      const that = this;
      this.clip(event, {
          resultObj: file,
          aspectRatio: 1,
          callback: function(data) {
            const formData = new FormData();
            formData.append('file', data);
            formData.append('angle', 0);
            // formData私有类对象，访问不到，可以通过get判断值是否传进去
            Upload(formData).then(res => {
              that.$toast.clear();
              that.personalData.faceImg = res.data;
            }).catch(err => {
              setTimeout(() => { that.$toast.clear(); }, 3000);
            });
          }
        }
      );
      this.show = false;
    },
    afterRead(file) {
      fileUtils.getOrientation(file.file).then((orient) => {
        lrz(file.file, { width: 1024 }).then(rst => {
          const fromData = new FormData();
          // 此时可以自行将文件上传至服务器
          let angle = '0';
          switch (orient) { // Orientation 拍摄方向,旋转角度
            case 6: // 顺时针90°
              angle = '90';
              break;
            case 3: // 逆时针90°
              angle = '180';
              break;
            case 8: // 180°
              angle = '270';
              break;
          }
          fromData.append('file', rst.origin);
          fromData.append('angle', angle);
          console.log(fromData.get('file'));
          Upload(fromData).then(res => {
            this.$toast.clear();
            this.personalData.faceImg = res.data;
          }).catch(err => {
            console.log(err);
            setTimeout(() => { this.$toast.clear(); }, 3000);
          });
          this.show = false;
        });
      });
    },
    showPopup() {
      this.show = !this.personalInfo.staff;
      //  this.show = true
    },
    // 校验手机号
    checkPhone() {
      let phone;
      if (this.personalData.phone === '') {
        phone = false;
        this.phonErrMsg = '请输入手机号';
      } else if (!/^1[3456789]\d{9}$/.test(this.personalData.phone)) {
        this.phonErrMsg = '手机号格式错误，请检查';
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    // 校验二维码
    checkCode() {
      if (this.showCaptcha) {
        let code;
        if (this.personalData.smsCode.length > 6) {
          this.personalData.smsCode = this.personalData.smsCode.slice(0, 6);
        }
        if (this.personalData.smsCode.length !== 6) {
          code = false;
          this.codeErrMsg = '请输入六位数验证码';
        } else {
          this.codeErrMsg = '';
          code = true;
        }
        return code;
      } else {
        return true
      }
    },
    checkName() {
      if (this.filedMustList.includes('name')) {
        let name;
        if (this.personalData.name === '') {
          name = false;
          this.nameErrMsg = '请输入姓名';
        } else {
          this.nameErrMsg = '';
          name = true;
        }
        return name;
      } else {
        return true;
      }
    },
    checkImg() {
      if (!this.isStaff) {
        if (this.filedMustList.includes('faceImg')) {
          let faceImg;
          if (this.personalData.faceImg == '') {
            faceImg = false;
            this.imgErr = true;
          } else {
            this.imgErr = false;
            faceImg = true;
          }
          return faceImg;
        } else {
          return true;
        }
      }
    },
    checkCompany() {
      if (this.filedMustList.includes('company')) {
        let company;
        if (this.personalData.company == '') {
          company = false;
          this.companyErrMsg = '请输入公司名称';
        } else {
          this.companyErrMsg = '';
          company = true;
        }
        return company;
      } else {
        return true;
      }
    },
    getVerificationCode() {
      // 函数节流
      if (!this.checkPhone()) {
        return;
      }
      if (!this.personalData.captchaResult && this.captchaInfo.open) {
        this.getImg();
        this.visible = true;
        return;
      }
      if (!this.codeFlag) return;
      this.codeFlag = false;

      // 修改按钮名称
      this.btnName = '发送中...';
      const data = { phone: this.personalData.phone };
      if (this.captchaInfo.open) {
        data.captchaUuid = this.personalData.uuid;
        data.captchaResult = this.personalData.captchaResult;
      }
      GetVerificationCode(data)
        .then(response => {
          // 发送成功
          let _time = this.countDown;
          this.codeInterval = setInterval(() => {
            _time -= 1;
            this.btnName = _time.toString() + '秒后重新获取';
            if (_time <= 0) {
              clearInterval(this.codeInterval);
              // 修改按钮名称
              this.btnName = this.btnDefault;
              this.personalData.captchaResult = '';
              // 恢复函数节流
              this.codeFlag = true;
            }
          }, 1000);
        })
        .catch(_ => {
          this.btnName = this.btnDefault;
          this.btnName = '获取验证码';
          this.codeFlag = true;
        });
    },
    getImg() {
      getCaptcha({}).then(res => {
        this.captchaInfo = res.data;
        this.personalData.uuid = res.data.uuid;
      });
    },
    beforeClose(action, done) {
      const that = this;
      if (action === 'confirm') {
        if (!this.personalData.captchaResult) {
          Toast.fail({
            icon: 'warning',
            message: '请输入',
            mask: true,
            className: 'newToast'
          });
          return;
        }
        done();
        that.getVerificationCode();
      } else if (action === 'cancel') {
        done(); // 关闭
        that.personalData.captchaResult = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/bind.less";
.height100 {
  height: 100vh;
}
.flex-column-center{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.vue-cropper {
  background: #000;
  .cropper-view-box {
    outline: 1px solid #fff !important;
    outline-color: #fff !important;
  }
}

.col-white {
  background-color: #000000;
  font-size: 18px;
  height: 80px;
  color: #FFFFFF;
  text-align: center;
}
</style>
